import React from 'react';
import { Link } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '60vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '40px 20px',
          background: 'var(--color-bg-cream)'
        }}>
          <h2 style={{
            fontSize: '1.8rem',
            color: 'var(--color-text-darker)',
            marginBottom: '16px'
          }}>Something went wrong</h2>
          <p style={{
            fontSize: '1.1rem',
            color: 'var(--color-text-gray)',
            marginBottom: '32px'
          }}>
            Please try refreshing the page.
          </p>
          <Link to="/" style={{
            background: 'var(--color-primary)',
            color: 'white',
            padding: '14px 32px',
            borderRadius: '8px',
            textDecoration: 'none',
            fontWeight: '600'
          }}
            onClick={() => this.setState({ hasError: false })}
          >
            Back to Home
          </Link>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
